import React from 'react'

import {
    CallLambdaGetEmode,
    CallLambdaEmodeCheck,
    CallLambdaEmodeOff,
} from './CallLambda'

// emodeoff用モーダル
const EmodeOffModal = ({ isOpen, onClose, isButtonDisabled }: { isOpen: boolean; onClose: () => void; isButtonDisabled: boolean }) => {
    if (!isOpen) return null
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                minWidth: '400px',
                overflow: 'hidden'
            }}>
                <div style={{
                    backgroundColor: '#4169E1',
                    color: '#fff',
                    padding: '15px 20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <h2 style={{ margin: 0, fontSize: '20px' }}>地震モードOFF画面</h2>
                    <span 
                        onClick={onClose}
                        style={{
                            fontSize: '28px',
                            cursor: 'pointer',
                            color: '#fff',
                            lineHeight: '1'
                        }}
                    >&times;</span>
                </div>
                <div style={{ padding: '30px' }}>
                    <p>地震モード　現在ON</p>
                    <button onClick={async () => {  
                        try {
                            await CallLambdaEmodeOff()
                            alert('地震モードを解除しました。')
                            onClose()
                        } catch (e) {
                            console.error('Error turning off emode: ', e)
                            alert('地震モード解除中にエラーが発生しました。')
                            onClose()
                        }   
                    }}
                    disabled={isButtonDisabled}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: isButtonDisabled ? '#6c757d' : '#dc3545',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: isButtonDisabled ? 'not-allowed' : 'pointer'
                    }}>{isButtonDisabled ? '地震発生中のためOFFできません' : '地震モードをOFFにする'}</button>
                </div>
            </div>
        </div>
    )
}

const App = (): React.JSX.Element => {

    // emode値の状態管理
    const [emodeValue, setEmodeValue] = React.useState<number>(0)
    // モーダルの開閉状態管理
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false)
    // emodeチェック結果の状態管理（1: ボタン無効, 0: ボタン有効）
    const [emodeCheckValue, setEmodeCheckValue] = React.useState<number>(0)

    // Dynamoからのemodeデータ取得
    const fetchEmode = React.useCallback(async () => {
        try {
            const emode_value = await CallLambdaGetEmode()
            console.log('Fetched emode_value: ', emode_value)
            // unknown型なので数値に変換
            setEmodeValue(Number(emode_value) || 0)
        } catch (e) {
            console.error('Error fetching emode_value: ', e)
        }
    }, [])

    React.useEffect(() => {
        (async () => {
           await fetchEmode()
        })()
        // 表示テスト用
        // setEmodeValue(1) // テストで1にする場合はコメント解除
    }, [fetchEmode])

    // モーダルを閉じる際の処理
    const handleCloseModal = () => {
        setIsModalOpen(false)
        fetchEmode() // 最新のemode値を再取得
    }

    return (
        <div>
            <EmodeOffModal isOpen={isModalOpen} onClose={handleCloseModal} isButtonDisabled={emodeCheckValue === 1} />
            <div>
                <h2>地震ネット広域版 地震モード管理</h2>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ textAlign: 'left' }}>
                    ユーザー名：
                    <input type="text" defaultValue="ユーザー名を入力" />
                </div>
                <div style={{ textAlign: 'center' }}>
                    現在の地震モード
                    <input type="text" readOnly value={emodeValue === 1 ? 'ON' : 'OFF'} 
                    style={{ border: '1px solid #ced4da', background: '#e9ecef', padding: '4px 8px', borderRadius: '4px', color: '#6c757d', pointerEvents: 'none', userSelect: 'none', marginLeft: '10px' }} />
                    <button onClick={async () => {
                        try {
                            const checkResult = await CallLambdaEmodeCheck()
                            setEmodeCheckValue(Number(checkResult) || 0)
                        } catch (e) {
                            console.error('Error checking emode: ', e)
                            setEmodeCheckValue(0)
                        }
                        setIsModalOpen(true)
                    }}
                    disabled={emodeValue !== 1}
                    style={{ marginLeft: '10px' }}>
                        状態切り替え
                    </button>
                </div>
            </div>
            <hr />
            <div>
                <table style={{ border: '1px solid #000', borderCollapse: 'collapse', width: '70%' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#4169E1' }}>
                            <th style={{ border: '1px solid #000', padding: '8px', color: '#fff' }}>No</th>
                            <th style={{ border: '1px solid #000', padding: '8px', color: '#fff' }}>地域名</th>
                            <th style={{ border: '1px solid #000', padding: '8px', color: '#fff' }}>ポイント名</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #000', padding: '8px' }}>1</td>
                            <td style={{ border: '1px solid #000', padding: '8px' }}>テスト地域</td>
                            <td style={{ border: '1px solid #000', padding: '8px' }}>テストセンター01</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default App;
